import React, {memo} from "react";

export const IconAi = memo(({color, addClass, size, animation}) => {
  return (
    <svg
      width={size || "20"}
      height={size || "20"}
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="9.5"
        stroke={color || "#000"}
        strokeWidth="1"
        fill="none"
      />
      <path
        d="M4.94101 17.225L7.93601 8.555L15.059 2.776L12.064 11.446L4.94101 17.225ZM8.78801 9.151L7.02901 14.243L11.212 10.849L12.971 5.757L8.78801 9.151Z"
        fill={color || "#000"}
        style={{
          transformOrigin: "center",
          animation: animation === "swing" ? "swing 1s ease-in-out 5" : "none",
        }}
      />
    </svg>
  );
});
